var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3136 0.382747L24.5028 12.1481C25.286 12.9716 24.7315 14.3795 23.6238 14.3795H22.3806V22.2231C22.3806 23.2632 21.9876 24.2607 21.2882 24.9962C20.5887 25.7317 19.64 26.1449 18.6508 26.1449H17.4076V16.9941C17.4076 15.9937 17.0442 15.0312 16.3915 14.3034C15.7389 13.5756 14.8464 13.1375 13.8967 13.0788L13.6779 13.0723H11.1914C10.2022 13.0723 9.25351 13.4855 8.55405 14.2209C7.85459 14.9564 7.46164 15.9539 7.46164 16.9941V26.1449H6.2184C5.22921 26.1449 4.28054 25.7317 3.58108 24.9962C2.88161 24.2607 2.48866 23.2632 2.48866 22.2231V14.3795H1.24542C0.13893 14.3795 -0.4168 12.9716 0.366444 12.1481L11.5556 0.382747C11.7888 0.137674 12.105 0 12.4346 0C12.7643 0 13.0804 0.137674 13.3136 0.382747ZM13.6779 15.6868C14.0076 15.6868 14.3238 15.8245 14.557 16.0697C14.7901 16.3148 14.9211 16.6474 14.9211 16.9941V26.1449H9.94813V16.9941C9.94817 16.6739 10.06 16.3648 10.2623 16.1256C10.4647 15.8863 10.7435 15.7334 11.0459 15.696L11.1914 15.6868H13.6779Z",
    fill: "#024202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7663e2f147c51b2224919eb305851aa1.svg";
export { ForwardRef as ReactComponent };